import { render, staticRenderFns } from "./P004.vue?vue&type=template&id=74bcb8e0"
import script from "./P004.vue?vue&type=script&lang=js"
export * from "./P004.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports